import React from "react";
import {HyperLink} from "../appUtils";

const Card = (props) => {
    let {
        title,
        children,
        className = "",
        lg,
        sm,
        size = "normal",
        padding = true,
        actions = "",
        extraLink = []
    } = props;
    let titleStyle = {fontSize: 14};
    if (lg) {
        titleStyle = {fontSize: 18};
    }
    if (sm) {
        titleStyle = {fontSize: 12};
    }
    // card-h-100
    return (
        <div className="card">
            {title ? <div className="card-header d-flex justify-content-between w-100">
                <div className="card-title">{title}</div>
                {actions ? <div style={{paddingRight: 20}}>{actions}</div> : null}

                {extraLink && extraLink.length ? (
                    <div>
                        {extraLink.map((item) => (
                            <HyperLink className="btn btn-outline-info btn-sm rounded-pill" link={item.link}
                                       key={item.link}>
                                {item.name}
                            </HyperLink>
                        ))}
                    </div>
                ) : null}

            </div> : null}
            <div className={`card-body ${size}`} style={!padding ? {padding: 0} : null}>
                {children}
            </div>
        </div>
    );
};
export default Card;
